import React from 'react';

/**
 * The four platform USPs.
 *
 * Ported from toastably-web/partials/section-usps.html. Identical on every landing
 * page, which is why it is a component rather than per-page data.
 *
 * Each item is an icon plus a text group: the group holds the heading and copy
 * together so they sit tighter to each other than to the icon.
 */
const Usps = () => (
  <section className="section-usps" aria-labelledby="usps-title">
    <div className="container">
      <div className="section-head">
        <h2 id="usps-title">Vorteile von Toastably</h2>
      </div>
      <div className="usp-grid">
        <div className="usp">
          <span className="usp-icon usp-icon-selection" aria-hidden="true"></span>
          <div className="usp-text">
            <h3>Grosse Auswahl</h3>
            <p>Hochzeitsanbieter:innen aus der ganzen Schweiz auf einer Plattform.</p>
          </div>
        </div>
        <div className="usp">
          <span className="usp-icon usp-icon-compare" aria-hidden="true"></span>
          <div className="usp-text">
            <h3>Einfaches Vergleichen</h3>
            <p>Klare Preise und Leistungen direkt ersichtlich.</p>
          </div>
        </div>
        <div className="usp">
          <span className="usp-icon usp-icon-booking" aria-hidden="true"></span>
          <div className="usp-text">
            <h3>Direkt buchen</h3>
            <p>Fixe Bestätigung mit sicherer Bezahlung über die Plattform.</p>
          </div>
        </div>
        <div className="usp">
          <span className="usp-icon usp-icon-pricing" aria-hidden="true"></span>
          <div className="usp-text">
            <h3>Faire Preise</h3>
            <p>Keine Plattformgebühren für suchende Paare.</p>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default Usps;
